// AUTO-GENERATED by /app/scripts/process_photos.py.
// Real Reformity Inc. project photos — do not edit by hand.
// Re-run the script to regenerate.

export const PROJECT_PHOTOS = {
  "fencing": [
    {
      "id": "fencing-aluminum-fence-img-20260610-wa0038",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-fence-img-20260610-wa0038.webp",
      "fallback": "/projects/fencing/aluminum-fence-img-20260610-wa0038.jpg",
      "alt": "Aluminum fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Fence",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "fencing-aluminum-fence-img-20250502-wa0058",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-fence-img-20250502-wa0058.webp",
      "fallback": "/projects/fencing/aluminum-fence-img-20250502-wa0058.jpg",
      "alt": "Aluminum fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-aluminum-fence-img-20250502-wa0057",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-fence-img-20250502-wa0057.webp",
      "fallback": "/projects/fencing/aluminum-fence-img-20250502-wa0057.jpg",
      "alt": "Aluminum fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-aluminum-fence-img-20250502-wa0056",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-fence-img-20250502-wa0056.webp",
      "fallback": "/projects/fencing/aluminum-fence-img-20250502-wa0056.jpg",
      "alt": "Aluminum fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-aluminum-rail-fence-img-82f2",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-rail-fence-img-82f2.webp",
      "fallback": "/projects/fencing/aluminum-rail-fence-img-82f2.jpg",
      "alt": "Aluminum Rail fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Rail Fence",
      "w": 1800,
      "h": 1136
    },
    {
      "id": "fencing-aluminum-rail-fence-img-20250613-wa0039",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-rail-fence-img-20250613-wa0039.webp",
      "fallback": "/projects/fencing/aluminum-rail-fence-img-20250613-wa0039.jpg",
      "alt": "Aluminum Rail fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Rail Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-aluminum-rail-fence-img-20250823-wa0075",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-rail-fence-img-20250823-wa0075.webp",
      "fallback": "/projects/fencing/aluminum-rail-fence-img-20250823-wa0075.jpg",
      "alt": "Aluminum Rail fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Rail Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-aluminum-rail-fence-img-20250823-wa0070",
      "service": "fencing",
      "src": "/projects/fencing/aluminum-rail-fence-img-20250823-wa0070.webp",
      "fallback": "/projects/fencing/aluminum-rail-fence-img-20250823-wa0070.jpg",
      "alt": "Aluminum Rail fence installation in the GTA by Reformity Inc.",
      "category": "Aluminum Rail Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-cedar-fence-img132-20f12",
      "service": "fencing",
      "src": "/projects/fencing/cedar-fence-img132-20f12.webp",
      "fallback": "/projects/fencing/cedar-fence-img132-20f12.jpg",
      "alt": "Cedar fence installation in the GTA by Reformity Inc.",
      "category": "Cedar Fence",
      "w": 800,
      "h": 1067
    },
    {
      "id": "fencing-cedar-fence-img215-21f21",
      "service": "fencing",
      "src": "/projects/fencing/cedar-fence-img215-21f21.webp",
      "fallback": "/projects/fencing/cedar-fence-img215-21f21.jpg",
      "alt": "Cedar fence installation in the GTA by Reformity Inc.",
      "category": "Cedar Fence",
      "w": 1333,
      "h": 1000
    },
    {
      "id": "fencing-cedar-fence-img235-21f31",
      "service": "fencing",
      "src": "/projects/fencing/cedar-fence-img235-21f31.webp",
      "fallback": "/projects/fencing/cedar-fence-img235-21f31.jpg",
      "alt": "Cedar fence installation in the GTA by Reformity Inc.",
      "category": "Cedar Fence",
      "w": 1280,
      "h": 720
    },
    {
      "id": "fencing-cedar-fence-img221-21f25",
      "service": "fencing",
      "src": "/projects/fencing/cedar-fence-img221-21f25.webp",
      "fallback": "/projects/fencing/cedar-fence-img221-21f25.jpg",
      "alt": "Cedar fence installation in the GTA by Reformity Inc.",
      "category": "Cedar Fence",
      "w": 1000,
      "h": 611
    },
    {
      "id": "fencing-chainlink-fence-img-20250402-wa0023",
      "service": "fencing",
      "src": "/projects/fencing/chainlink-fence-img-20250402-wa0023.webp",
      "fallback": "/projects/fencing/chainlink-fence-img-20250402-wa0023.jpg",
      "alt": "Chainlink fence installation in the GTA by Reformity Inc.",
      "category": "Chainlink Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-chainlink-fence-img-20250402-wa0024",
      "service": "fencing",
      "src": "/projects/fencing/chainlink-fence-img-20250402-wa0024.webp",
      "fallback": "/projects/fencing/chainlink-fence-img-20250402-wa0024.jpg",
      "alt": "Chainlink fence installation in the GTA by Reformity Inc.",
      "category": "Chainlink Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-chainlink-fence-img-20250402-wa0030",
      "service": "fencing",
      "src": "/projects/fencing/chainlink-fence-img-20250402-wa0030.webp",
      "fallback": "/projects/fencing/chainlink-fence-img-20250402-wa0030.jpg",
      "alt": "Chainlink fence installation in the GTA by Reformity Inc.",
      "category": "Chainlink Fence",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "fencing-chainlink-fence-img-20250402-wa0025",
      "service": "fencing",
      "src": "/projects/fencing/chainlink-fence-img-20250402-wa0025.webp",
      "fallback": "/projects/fencing/chainlink-fence-img-20250402-wa0025.jpg",
      "alt": "Chainlink fence installation in the GTA by Reformity Inc.",
      "category": "Chainlink Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-composite-fence-compositefence1",
      "service": "fencing",
      "src": "/projects/fencing/composite-fence-compositefence1.webp",
      "fallback": "/projects/fencing/composite-fence-compositefence1.jpg",
      "alt": "Composite fence installation in the GTA by Reformity Inc.",
      "category": "Composite Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-composite-fence-compositefence5",
      "service": "fencing",
      "src": "/projects/fencing/composite-fence-compositefence5.webp",
      "fallback": "/projects/fencing/composite-fence-compositefence5.jpg",
      "alt": "Composite fence installation in the GTA by Reformity Inc.",
      "category": "Composite Fence",
      "w": 1702,
      "h": 1276
    },
    {
      "id": "fencing-composite-fence-screenshot-2025-05-28-132542",
      "service": "fencing",
      "src": "/projects/fencing/composite-fence-screenshot-2025-05-28-132542.webp",
      "fallback": "/projects/fencing/composite-fence-screenshot-2025-05-28-132542.jpg",
      "alt": "Composite fence installation in the GTA by Reformity Inc.",
      "category": "Composite Fence",
      "w": 1243,
      "h": 692
    },
    {
      "id": "fencing-composite-fence-compositefence6",
      "service": "fencing",
      "src": "/projects/fencing/composite-fence-compositefence6.webp",
      "fallback": "/projects/fencing/composite-fence-compositefence6.jpg",
      "alt": "Composite fence installation in the GTA by Reformity Inc.",
      "category": "Composite Fence",
      "w": 1706,
      "h": 1280
    },
    {
      "id": "fencing-farm-fence-1",
      "service": "fencing",
      "src": "/projects/fencing/farm-fence-1.webp",
      "fallback": "/projects/fencing/farm-fence-1.jpg",
      "alt": "Farm fence installation in the GTA by Reformity Inc.",
      "category": "Farm Fence",
      "w": 1093,
      "h": 817
    },
    {
      "id": "fencing-farm-fence-2",
      "service": "fencing",
      "src": "/projects/fencing/farm-fence-2.webp",
      "fallback": "/projects/fencing/farm-fence-2.jpg",
      "alt": "Farm fence installation in the GTA by Reformity Inc.",
      "category": "Farm Fence",
      "w": 1044,
      "h": 812
    },
    {
      "id": "fencing-farm-fence-whatsapp-image-2025-04-25-at-17-01-21-47c3f218",
      "service": "fencing",
      "src": "/projects/fencing/farm-fence-whatsapp-image-2025-04-25-at-17-01-21-47c3f218.webp",
      "fallback": "/projects/fencing/farm-fence-whatsapp-image-2025-04-25-at-17-01-21-47c3f218.jpg",
      "alt": "Farm fence installation in the GTA by Reformity Inc.",
      "category": "Farm Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-farm-fence-whatsapp-image-2025-04-25-at-17-01-21-33d0d0c1",
      "service": "fencing",
      "src": "/projects/fencing/farm-fence-whatsapp-image-2025-04-25-at-17-01-21-33d0d0c1.webp",
      "fallback": "/projects/fencing/farm-fence-whatsapp-image-2025-04-25-at-17-01-21-33d0d0c1.jpg",
      "alt": "Farm fence installation in the GTA by Reformity Inc.",
      "category": "Farm Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-gates-pro-epxft7mb",
      "service": "fencing",
      "src": "/projects/fencing/gates-pro-epxft7mb.webp",
      "fallback": "/projects/fencing/gates-pro-epxft7mb.jpg",
      "alt": "Gates fence installation in the GTA by Reformity Inc.",
      "category": "Gates",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-gates-img-20230607-wa0018",
      "service": "fencing",
      "src": "/projects/fencing/gates-img-20230607-wa0018.webp",
      "fallback": "/projects/fencing/gates-img-20230607-wa0018.jpg",
      "alt": "Gates fence installation in the GTA by Reformity Inc.",
      "category": "Gates",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-gates-whatsapp-image-2023-09-30-at-14-36-29",
      "service": "fencing",
      "src": "/projects/fencing/gates-whatsapp-image-2023-09-30-at-14-36-29.webp",
      "fallback": "/projects/fencing/gates-whatsapp-image-2023-09-30-at-14-36-29.jpg",
      "alt": "Gates fence installation in the GTA by Reformity Inc.",
      "category": "Gates",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-gates-whatsapp-image-2023-09-30-at-14-37-28",
      "service": "fencing",
      "src": "/projects/fencing/gates-whatsapp-image-2023-09-30-at-14-37-28.webp",
      "fallback": "/projects/fencing/gates-whatsapp-image-2023-09-30-at-14-37-28.jpg",
      "alt": "Gates fence installation in the GTA by Reformity Inc.",
      "category": "Gates",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "fencing-specialty-fences-img-20240603-wa0019",
      "service": "fencing",
      "src": "/projects/fencing/specialty-fences-img-20240603-wa0019.webp",
      "fallback": "/projects/fencing/specialty-fences-img-20240603-wa0019.jpg",
      "alt": "Specialty S fence installation in the GTA by Reformity Inc.",
      "category": "Specialty Fences",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-specialty-fences-img-20240603-wa0020",
      "service": "fencing",
      "src": "/projects/fencing/specialty-fences-img-20240603-wa0020.webp",
      "fallback": "/projects/fencing/specialty-fences-img-20240603-wa0020.jpg",
      "alt": "Specialty S fence installation in the GTA by Reformity Inc.",
      "category": "Specialty Fences",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-specialty-fences-img-20240603-wa0016",
      "service": "fencing",
      "src": "/projects/fencing/specialty-fences-img-20240603-wa0016.webp",
      "fallback": "/projects/fencing/specialty-fences-img-20240603-wa0016.jpg",
      "alt": "Specialty S fence installation in the GTA by Reformity Inc.",
      "category": "Specialty Fences",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-specialty-fences-img-20240603-wa0017",
      "service": "fencing",
      "src": "/projects/fencing/specialty-fences-img-20240603-wa0017.webp",
      "fallback": "/projects/fencing/specialty-fences-img-20240603-wa0017.jpg",
      "alt": "Specialty S fence installation in the GTA by Reformity Inc.",
      "category": "Specialty Fences",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-vinyl-fence-lavavinylfence",
      "service": "fencing",
      "src": "/projects/fencing/vinyl-fence-lavavinylfence.webp",
      "fallback": "/projects/fencing/vinyl-fence-lavavinylfence.jpg",
      "alt": "Vinyl fence installation in the GTA by Reformity Inc.",
      "category": "Vinyl Fence",
      "w": 1800,
      "h": 1349
    },
    {
      "id": "fencing-vinyl-fence-77159f1c-2d30-40bf-9d10-50a9dfef26a1",
      "service": "fencing",
      "src": "/projects/fencing/vinyl-fence-77159f1c-2d30-40bf-9d10-50a9dfef26a1.webp",
      "fallback": "/projects/fencing/vinyl-fence-77159f1c-2d30-40bf-9d10-50a9dfef26a1.jpg",
      "alt": "Vinyl fence installation in the GTA by Reformity Inc.",
      "category": "Vinyl Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-vinyl-fence-whitevinylfence",
      "service": "fencing",
      "src": "/projects/fencing/vinyl-fence-whitevinylfence.webp",
      "fallback": "/projects/fencing/vinyl-fence-whitevinylfence.jpg",
      "alt": "Vinyl fence installation in the GTA by Reformity Inc.",
      "category": "Vinyl Fence",
      "w": 1800,
      "h": 1275
    },
    {
      "id": "fencing-vinyl-fence-tan-l-shape",
      "service": "fencing",
      "src": "/projects/fencing/vinyl-fence-tan-l-shape.webp",
      "fallback": "/projects/fencing/vinyl-fence-tan-l-shape.jpg",
      "alt": "Vinyl fence installation in the GTA by Reformity Inc.",
      "category": "Vinyl Fence",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "fencing-wire-fence-img-20250801-wa0011",
      "service": "fencing",
      "src": "/projects/fencing/wire-fence-img-20250801-wa0011.webp",
      "fallback": "/projects/fencing/wire-fence-img-20250801-wa0011.jpg",
      "alt": "Wire fence installation in the GTA by Reformity Inc.",
      "category": "Wire Fence",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "fencing-wire-fence-img-20250801-wa0012",
      "service": "fencing",
      "src": "/projects/fencing/wire-fence-img-20250801-wa0012.webp",
      "fallback": "/projects/fencing/wire-fence-img-20250801-wa0012.jpg",
      "alt": "Wire fence installation in the GTA by Reformity Inc.",
      "category": "Wire Fence",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "fencing-wire-fence-img-20250702-wa0065-1",
      "service": "fencing",
      "src": "/projects/fencing/wire-fence-img-20250702-wa0065-1.webp",
      "fallback": "/projects/fencing/wire-fence-img-20250702-wa0065-1.jpg",
      "alt": "Wire fence installation in the GTA by Reformity Inc.",
      "category": "Wire Fence",
      "w": 1600,
      "h": 1200
    },
    {
      "id": "fencing-wire-fence-img-20250801-wa0010",
      "service": "fencing",
      "src": "/projects/fencing/wire-fence-img-20250801-wa0010.webp",
      "fallback": "/projects/fencing/wire-fence-img-20250801-wa0010.jpg",
      "alt": "Wire fence installation in the GTA by Reformity Inc.",
      "category": "Wire Fence",
      "w": 1200,
      "h": 1600
    }
  ],
  "interlocking": [
    {
      "id": "interlocking-interlocking-20241123-125714",
      "service": "interlocking",
      "src": "/projects/interlocking/interlocking-20241123-125714.webp",
      "fallback": "/projects/interlocking/interlocking-20241123-125714.jpg",
      "alt": "Interlocking driveway and walkway installation in the GTA",
      "category": "Interlocking",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "interlocking-interlocking-unilock",
      "service": "interlocking",
      "src": "/projects/interlocking/interlocking-unilock.webp",
      "fallback": "/projects/interlocking/interlocking-unilock.jpg",
      "alt": "Interlocking driveway and walkway installation in the GTA",
      "category": "Interlocking",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "interlocking-interlocking-screenshot-2024-06-16-114912",
      "service": "interlocking",
      "src": "/projects/interlocking/interlocking-screenshot-2024-06-16-114912.webp",
      "fallback": "/projects/interlocking/interlocking-screenshot-2024-06-16-114912.jpg",
      "alt": "Interlocking driveway and walkway installation in the GTA",
      "category": "Interlocking",
      "w": 811,
      "h": 750
    },
    {
      "id": "interlocking-interlocking-screenshot-2025-03-23-161347",
      "service": "interlocking",
      "src": "/projects/interlocking/interlocking-screenshot-2025-03-23-161347.webp",
      "fallback": "/projects/interlocking/interlocking-screenshot-2025-03-23-161347.jpg",
      "alt": "Interlocking driveway and walkway installation in the GTA",
      "category": "Interlocking",
      "w": 817,
      "h": 749
    },
    {
      "id": "interlocking-natural-flagstone-screenshot-2026-03-17-115721",
      "service": "interlocking",
      "src": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115721.webp",
      "fallback": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115721.jpg",
      "alt": "Natural flagstone walkway installation in the GTA",
      "category": "Natural Flagstone",
      "w": 699,
      "h": 678
    },
    {
      "id": "interlocking-natural-flagstone-screenshot-2026-03-17-115654",
      "service": "interlocking",
      "src": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115654.webp",
      "fallback": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115654.jpg",
      "alt": "Natural flagstone walkway installation in the GTA",
      "category": "Natural Flagstone",
      "w": 746,
      "h": 530
    },
    {
      "id": "interlocking-natural-flagstone-screenshot-2026-03-17-115704",
      "service": "interlocking",
      "src": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115704.webp",
      "fallback": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115704.jpg",
      "alt": "Natural flagstone walkway installation in the GTA",
      "category": "Natural Flagstone",
      "w": 762,
      "h": 532
    },
    {
      "id": "interlocking-natural-flagstone-screenshot-2026-03-17-115646",
      "service": "interlocking",
      "src": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115646.webp",
      "fallback": "/projects/interlocking/natural-flagstone-screenshot-2026-03-17-115646.jpg",
      "alt": "Natural flagstone walkway installation in the GTA",
      "category": "Natural Flagstone",
      "w": 781,
      "h": 505
    },
    {
      "id": "interlocking-retaining-wall-design-img-20250530-wa0037",
      "service": "interlocking",
      "src": "/projects/interlocking/retaining-wall-design-img-20250530-wa0037.webp",
      "fallback": "/projects/interlocking/retaining-wall-design-img-20250530-wa0037.jpg",
      "alt": "Retaining wall installation in the GTA",
      "category": "Retaining Wall Design",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "interlocking-retaining-wall-design-img-20250530-wa0038",
      "service": "interlocking",
      "src": "/projects/interlocking/retaining-wall-design-img-20250530-wa0038.webp",
      "fallback": "/projects/interlocking/retaining-wall-design-img-20250530-wa0038.jpg",
      "alt": "Retaining wall installation in the GTA",
      "category": "Retaining Wall Design",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "interlocking-retaining-wall-design-img-20250530-wa0041",
      "service": "interlocking",
      "src": "/projects/interlocking/retaining-wall-design-img-20250530-wa0041.webp",
      "fallback": "/projects/interlocking/retaining-wall-design-img-20250530-wa0041.jpg",
      "alt": "Retaining wall installation in the GTA",
      "category": "Retaining Wall Design",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "interlocking-retaining-wall-design-img-20250530-wa0039",
      "service": "interlocking",
      "src": "/projects/interlocking/retaining-wall-design-img-20250530-wa0039.webp",
      "fallback": "/projects/interlocking/retaining-wall-design-img-20250530-wa0039.jpg",
      "alt": "Retaining wall installation in the GTA",
      "category": "Retaining Wall Design",
      "w": 1800,
      "h": 1350
    }
  ],
  "decking": [
    {
      "id": "decking-decks-20240912-120844",
      "service": "decking",
      "src": "/projects/decking/decks-20240912-120844.webp",
      "fallback": "/projects/decking/decks-20240912-120844.jpg",
      "alt": "Custom backyard deck build in the GTA",
      "category": "Decks",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "decking-decks-20241123-125828",
      "service": "decking",
      "src": "/projects/decking/decks-20241123-125828.webp",
      "fallback": "/projects/decking/decks-20241123-125828.jpg",
      "alt": "Custom backyard deck build in the GTA",
      "category": "Decks",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "decking-decks-20241123-125820",
      "service": "decking",
      "src": "/projects/decking/decks-20241123-125820.webp",
      "fallback": "/projects/decking/decks-20241123-125820.jpg",
      "alt": "Custom backyard deck build in the GTA",
      "category": "Decks",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "decking-decks-20240621-151344",
      "service": "decking",
      "src": "/projects/decking/decks-20240621-151344.webp",
      "fallback": "/projects/decking/decks-20240621-151344.jpg",
      "alt": "Custom backyard deck build in the GTA",
      "category": "Decks",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "decking-frameless-glass-railing-img-7053",
      "service": "decking",
      "src": "/projects/decking/frameless-glass-railing-img-7053.webp",
      "fallback": "/projects/decking/frameless-glass-railing-img-7053.jpg",
      "alt": "Frameless glass deck railing in the GTA",
      "category": "Frameless Glass Railing",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-frameless-glass-railing-img-7112",
      "service": "decking",
      "src": "/projects/decking/frameless-glass-railing-img-7112.webp",
      "fallback": "/projects/decking/frameless-glass-railing-img-7112.jpg",
      "alt": "Frameless glass deck railing in the GTA",
      "category": "Frameless Glass Railing",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-frameless-glass-railing-img-5724",
      "service": "decking",
      "src": "/projects/decking/frameless-glass-railing-img-5724.webp",
      "fallback": "/projects/decking/frameless-glass-railing-img-5724.jpg",
      "alt": "Frameless glass deck railing in the GTA",
      "category": "Frameless Glass Railing",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-frameless-glass-railing-img-6234",
      "service": "decking",
      "src": "/projects/decking/frameless-glass-railing-img-6234.webp",
      "fallback": "/projects/decking/frameless-glass-railing-img-6234.jpg",
      "alt": "Frameless glass deck railing in the GTA",
      "category": "Frameless Glass Railing",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-pergola-perg-oakville",
      "service": "decking",
      "src": "/projects/decking/pergola-perg-oakville.webp",
      "fallback": "/projects/decking/pergola-perg-oakville.jpg",
      "alt": "Custom pergola build in the GTA",
      "category": "Pergola",
      "w": 1536,
      "h": 1024
    },
    {
      "id": "decking-pergola-perg-niagara",
      "service": "decking",
      "src": "/projects/decking/pergola-perg-niagara.webp",
      "fallback": "/projects/decking/pergola-perg-niagara.jpg",
      "alt": "Custom pergola build in the GTA",
      "category": "Pergola",
      "w": 936,
      "h": 701
    },
    {
      "id": "decking-pergola-img-20241116-wa0051",
      "service": "decking",
      "src": "/projects/decking/pergola-img-20241116-wa0051.webp",
      "fallback": "/projects/decking/pergola-img-20241116-wa0051.jpg",
      "alt": "Custom pergola build in the GTA",
      "category": "Pergola",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "decking-pergola-img-20241116-wa0048",
      "service": "decking",
      "src": "/projects/decking/pergola-img-20241116-wa0048.webp",
      "fallback": "/projects/decking/pergola-img-20241116-wa0048.jpg",
      "alt": "Custom pergola build in the GTA",
      "category": "Pergola",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-sunrooms-img-1105",
      "service": "decking",
      "src": "/projects/decking/sunrooms-img-1105.webp",
      "fallback": "/projects/decking/sunrooms-img-1105.jpg",
      "alt": "Sunroom build in the GTA",
      "category": "Sunrooms",
      "w": 1024,
      "h": 1536
    },
    {
      "id": "decking-sunrooms-img-3302",
      "service": "decking",
      "src": "/projects/decking/sunrooms-img-3302.webp",
      "fallback": "/projects/decking/sunrooms-img-3302.jpg",
      "alt": "Sunroom build in the GTA",
      "category": "Sunrooms",
      "w": 1800,
      "h": 1012
    },
    {
      "id": "decking-sunrooms-img-7392",
      "service": "decking",
      "src": "/projects/decking/sunrooms-img-7392.webp",
      "fallback": "/projects/decking/sunrooms-img-7392.jpg",
      "alt": "Sunroom build in the GTA",
      "category": "Sunrooms",
      "w": 1131,
      "h": 848
    },
    {
      "id": "decking-sunrooms-img-6848",
      "service": "decking",
      "src": "/projects/decking/sunrooms-img-6848.webp",
      "fallback": "/projects/decking/sunrooms-img-6848.jpg",
      "alt": "Sunroom build in the GTA",
      "category": "Sunrooms",
      "w": 600,
      "h": 600
    },
    {
      "id": "decking-carport-img-20241116-wa0051",
      "service": "decking",
      "src": "/projects/decking/carport-img-20241116-wa0051.webp",
      "fallback": "/projects/decking/carport-img-20241116-wa0051.jpg",
      "alt": "Carport installation in the GTA",
      "category": "Carport",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "decking-carport-img-20241116-wa0050",
      "service": "decking",
      "src": "/projects/decking/carport-img-20241116-wa0050.webp",
      "fallback": "/projects/decking/carport-img-20241116-wa0050.jpg",
      "alt": "Carport installation in the GTA",
      "category": "Carport",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-carport-img-20241116-wa0048",
      "service": "decking",
      "src": "/projects/decking/carport-img-20241116-wa0048.webp",
      "fallback": "/projects/decking/carport-img-20241116-wa0048.jpg",
      "alt": "Carport installation in the GTA",
      "category": "Carport",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "decking-carport-carporteg2",
      "service": "decking",
      "src": "/projects/decking/carport-carporteg2.webp",
      "fallback": "/projects/decking/carport-carporteg2.jpg",
      "alt": "Carport installation in the GTA",
      "category": "Carport",
      "w": 600,
      "h": 526
    }
  ],
  "concrete": [
    {
      "id": "concrete-asphalt-img-20260504-wa0105",
      "service": "concrete",
      "src": "/projects/concrete/asphalt-img-20260504-wa0105.webp",
      "fallback": "/projects/concrete/asphalt-img-20260504-wa0105.jpg",
      "alt": "Asphalt driveway installation in the GTA",
      "category": "Asphalt",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "concrete-asphalt-img-20260504-wa0104",
      "service": "concrete",
      "src": "/projects/concrete/asphalt-img-20260504-wa0104.webp",
      "fallback": "/projects/concrete/asphalt-img-20260504-wa0104.jpg",
      "alt": "Asphalt driveway installation in the GTA",
      "category": "Asphalt",
      "w": 1013,
      "h": 1800
    },
    {
      "id": "concrete-asphalt-img-20260504-wa0102",
      "service": "concrete",
      "src": "/projects/concrete/asphalt-img-20260504-wa0102.webp",
      "fallback": "/projects/concrete/asphalt-img-20260504-wa0102.jpg",
      "alt": "Asphalt driveway installation in the GTA",
      "category": "Asphalt",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "concrete-asphalt-img-20260504-wa0103",
      "service": "concrete",
      "src": "/projects/concrete/asphalt-img-20260504-wa0103.webp",
      "fallback": "/projects/concrete/asphalt-img-20260504-wa0103.jpg",
      "alt": "Asphalt driveway installation in the GTA",
      "category": "Asphalt",
      "w": 1013,
      "h": 1800
    },
    {
      "id": "concrete-concrete-20251020-113738",
      "service": "concrete",
      "src": "/projects/concrete/concrete-20251020-113738.webp",
      "fallback": "/projects/concrete/concrete-20251020-113738.jpg",
      "alt": "Concrete driveway and walkway pour in the GTA",
      "category": "Concrete",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "concrete-concrete-20251020-113742",
      "service": "concrete",
      "src": "/projects/concrete/concrete-20251020-113742.webp",
      "fallback": "/projects/concrete/concrete-20251020-113742.jpg",
      "alt": "Concrete driveway and walkway pour in the GTA",
      "category": "Concrete",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "concrete-concrete-20251020-113746",
      "service": "concrete",
      "src": "/projects/concrete/concrete-20251020-113746.webp",
      "fallback": "/projects/concrete/concrete-20251020-113746.jpg",
      "alt": "Concrete driveway and walkway pour in the GTA",
      "category": "Concrete",
      "w": 1800,
      "h": 1013
    },
    {
      "id": "concrete-concrete-img-20260508-wa0069",
      "service": "concrete",
      "src": "/projects/concrete/concrete-img-20260508-wa0069.webp",
      "fallback": "/projects/concrete/concrete-img-20260508-wa0069.jpg",
      "alt": "Concrete driveway and walkway pour in the GTA",
      "category": "Concrete",
      "w": 1350,
      "h": 1800
    }
  ],
  "landscaping": [
    {
      "id": "landscaping-sodding-img-20260502-wa0054",
      "service": "landscaping",
      "src": "/projects/landscaping/sodding-img-20260502-wa0054.webp",
      "fallback": "/projects/landscaping/sodding-img-20260502-wa0054.jpg",
      "alt": "Sod installation in the GTA",
      "category": "Sodding",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "landscaping-sodding-img-20260502-wa0053",
      "service": "landscaping",
      "src": "/projects/landscaping/sodding-img-20260502-wa0053.webp",
      "fallback": "/projects/landscaping/sodding-img-20260502-wa0053.jpg",
      "alt": "Sod installation in the GTA",
      "category": "Sodding",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "landscaping-sodding-img-20260502-wa0044",
      "service": "landscaping",
      "src": "/projects/landscaping/sodding-img-20260502-wa0044.webp",
      "fallback": "/projects/landscaping/sodding-img-20260502-wa0044.jpg",
      "alt": "Sod installation in the GTA",
      "category": "Sodding",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "landscaping-sodding-img-20260502-wa0048",
      "service": "landscaping",
      "src": "/projects/landscaping/sodding-img-20260502-wa0048.webp",
      "fallback": "/projects/landscaping/sodding-img-20260502-wa0048.jpg",
      "alt": "Sod installation in the GTA",
      "category": "Sodding",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "landscaping-shed-designs-woodshed1",
      "service": "landscaping",
      "src": "/projects/landscaping/shed-designs-woodshed1.webp",
      "fallback": "/projects/landscaping/shed-designs-woodshed1.jpg",
      "alt": "Custom shed build in the GTA",
      "category": "Shed Designs",
      "w": 1281,
      "h": 982
    },
    {
      "id": "landscaping-shed-designs-woodshed3",
      "service": "landscaping",
      "src": "/projects/landscaping/shed-designs-woodshed3.webp",
      "fallback": "/projects/landscaping/shed-designs-woodshed3.jpg",
      "alt": "Custom shed build in the GTA",
      "category": "Shed Designs",
      "w": 1289,
      "h": 1015
    },
    {
      "id": "landscaping-shed-designs-woodshed2",
      "service": "landscaping",
      "src": "/projects/landscaping/shed-designs-woodshed2.webp",
      "fallback": "/projects/landscaping/shed-designs-woodshed2.jpg",
      "alt": "Custom shed build in the GTA",
      "category": "Shed Designs",
      "w": 904,
      "h": 820
    }
  ],
  "renovations": [
    {
      "id": "renovations-bathrooms-img-20251024-wa0037",
      "service": "renovations",
      "src": "/projects/renovations/bathrooms-img-20251024-wa0037.webp",
      "fallback": "/projects/renovations/bathrooms-img-20251024-wa0037.jpg",
      "alt": "Bathroom renovation in the GTA",
      "category": "Bathrooms",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "renovations-bathrooms-img-20251024-wa0030",
      "service": "renovations",
      "src": "/projects/renovations/bathrooms-img-20251024-wa0030.webp",
      "fallback": "/projects/renovations/bathrooms-img-20251024-wa0030.jpg",
      "alt": "Bathroom renovation in the GTA",
      "category": "Bathrooms",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "renovations-bathrooms-img-20251024-wa0027",
      "service": "renovations",
      "src": "/projects/renovations/bathrooms-img-20251024-wa0027.webp",
      "fallback": "/projects/renovations/bathrooms-img-20251024-wa0027.jpg",
      "alt": "Bathroom renovation in the GTA",
      "category": "Bathrooms",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "renovations-bathrooms-img-20251024-wa0036",
      "service": "renovations",
      "src": "/projects/renovations/bathrooms-img-20251024-wa0036.webp",
      "fallback": "/projects/renovations/bathrooms-img-20251024-wa0036.jpg",
      "alt": "Bathroom renovation in the GTA",
      "category": "Bathrooms",
      "w": 1200,
      "h": 1600
    },
    {
      "id": "renovations-kitchen-img-20240304-wa0059",
      "service": "renovations",
      "src": "/projects/renovations/kitchen-img-20240304-wa0059.webp",
      "fallback": "/projects/renovations/kitchen-img-20240304-wa0059.jpg",
      "alt": "Kitchen renovation in the GTA",
      "category": "Kitchen",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-kitchen-img-20240304-wa0052",
      "service": "renovations",
      "src": "/projects/renovations/kitchen-img-20240304-wa0052.webp",
      "fallback": "/projects/renovations/kitchen-img-20240304-wa0052.jpg",
      "alt": "Kitchen renovation in the GTA",
      "category": "Kitchen",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-kitchen-img-20251024-wa0043",
      "service": "renovations",
      "src": "/projects/renovations/kitchen-img-20251024-wa0043.webp",
      "fallback": "/projects/renovations/kitchen-img-20251024-wa0043.jpg",
      "alt": "Kitchen renovation in the GTA",
      "category": "Kitchen",
      "w": 1600,
      "h": 1200
    },
    {
      "id": "renovations-kitchen-img-20251024-wa0044",
      "service": "renovations",
      "src": "/projects/renovations/kitchen-img-20251024-wa0044.webp",
      "fallback": "/projects/renovations/kitchen-img-20251024-wa0044.jpg",
      "alt": "Kitchen renovation in the GTA",
      "category": "Kitchen",
      "w": 1600,
      "h": 1200
    },
    {
      "id": "renovations-flooring-img2253-vaughan-1",
      "service": "renovations",
      "src": "/projects/renovations/flooring-img2253-vaughan-1.webp",
      "fallback": "/projects/renovations/flooring-img2253-vaughan-1.jpg",
      "alt": "Flooring installation in the GTA",
      "category": "Flooring",
      "w": 720,
      "h": 777
    },
    {
      "id": "renovations-flooring-img2134-toronto-3",
      "service": "renovations",
      "src": "/projects/renovations/flooring-img2134-toronto-3.webp",
      "fallback": "/projects/renovations/flooring-img2134-toronto-3.jpg",
      "alt": "Flooring installation in the GTA",
      "category": "Flooring",
      "w": 960,
      "h": 720
    },
    {
      "id": "renovations-flooring-img2323-vaughan-1",
      "service": "renovations",
      "src": "/projects/renovations/flooring-img2323-vaughan-1.webp",
      "fallback": "/projects/renovations/flooring-img2323-vaughan-1.jpg",
      "alt": "Flooring installation in the GTA",
      "category": "Flooring",
      "w": 720,
      "h": 960
    },
    {
      "id": "renovations-flooring-img2324-vaughan-2",
      "service": "renovations",
      "src": "/projects/renovations/flooring-img2324-vaughan-2.webp",
      "fallback": "/projects/renovations/flooring-img2324-vaughan-2.jpg",
      "alt": "Flooring installation in the GTA",
      "category": "Flooring",
      "w": 720,
      "h": 960
    },
    {
      "id": "renovations-interior-railings-img-20250504-wa0019",
      "service": "renovations",
      "src": "/projects/renovations/interior-railings-img-20250504-wa0019.webp",
      "fallback": "/projects/renovations/interior-railings-img-20250504-wa0019.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Interior Railings",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-interior-railings-img-20250504-wa0018",
      "service": "renovations",
      "src": "/projects/renovations/interior-railings-img-20250504-wa0018.webp",
      "fallback": "/projects/renovations/interior-railings-img-20250504-wa0018.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Interior Railings",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-interior-railings-img-20250504-wa0021",
      "service": "renovations",
      "src": "/projects/renovations/interior-railings-img-20250504-wa0021.webp",
      "fallback": "/projects/renovations/interior-railings-img-20250504-wa0021.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Interior Railings",
      "w": 1012,
      "h": 1800
    },
    {
      "id": "renovations-interior-railings-img-20250504-wa0013",
      "service": "renovations",
      "src": "/projects/renovations/interior-railings-img-20250504-wa0013.webp",
      "fallback": "/projects/renovations/interior-railings-img-20250504-wa0013.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Interior Railings",
      "w": 810,
      "h": 1800
    },
    {
      "id": "renovations-railings-img-6006",
      "service": "renovations",
      "src": "/projects/renovations/railings-img-6006.webp",
      "fallback": "/projects/renovations/railings-img-6006.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Railings",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "renovations-railings-img-5778",
      "service": "renovations",
      "src": "/projects/renovations/railings-img-5778.webp",
      "fallback": "/projects/renovations/railings-img-5778.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Railings",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "renovations-railings-received-332064509500494",
      "service": "renovations",
      "src": "/projects/renovations/railings-received-332064509500494.webp",
      "fallback": "/projects/renovations/railings-received-332064509500494.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Railings",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "renovations-railings-received-1053388015635897",
      "service": "renovations",
      "src": "/projects/renovations/railings-received-1053388015635897.webp",
      "fallback": "/projects/renovations/railings-received-1053388015635897.jpg",
      "alt": "Interior railing installation in the GTA",
      "category": "Railings",
      "w": 1800,
      "h": 1350
    },
    {
      "id": "renovations-painting-and-staining-img-20250423-wa0084",
      "service": "renovations",
      "src": "/projects/renovations/painting-and-staining-img-20250423-wa0084.webp",
      "fallback": "/projects/renovations/painting-and-staining-img-20250423-wa0084.jpg",
      "alt": "Interior painting and staining in the GTA",
      "category": "Painting And Staining",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-painting-and-staining-img-20250423-wa0088",
      "service": "renovations",
      "src": "/projects/renovations/painting-and-staining-img-20250423-wa0088.webp",
      "fallback": "/projects/renovations/painting-and-staining-img-20250423-wa0088.jpg",
      "alt": "Interior painting and staining in the GTA",
      "category": "Painting And Staining",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-painting-and-staining-img-20250423-wa0085",
      "service": "renovations",
      "src": "/projects/renovations/painting-and-staining-img-20250423-wa0085.webp",
      "fallback": "/projects/renovations/painting-and-staining-img-20250423-wa0085.jpg",
      "alt": "Interior painting and staining in the GTA",
      "category": "Painting And Staining",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-painting-and-staining-img-20250423-wa0079",
      "service": "renovations",
      "src": "/projects/renovations/painting-and-staining-img-20250423-wa0079.webp",
      "fallback": "/projects/renovations/painting-and-staining-img-20250423-wa0079.jpg",
      "alt": "Interior painting and staining in the GTA",
      "category": "Painting And Staining",
      "w": 1350,
      "h": 1800
    },
    {
      "id": "renovations-waterproofing-img-20240716-112238",
      "service": "renovations",
      "src": "/projects/renovations/waterproofing-img-20240716-112238.webp",
      "fallback": "/projects/renovations/waterproofing-img-20240716-112238.jpg",
      "alt": "Basement waterproofing in the GTA",
      "category": "Waterproofing",
      "w": 449,
      "h": 798
    },
    {
      "id": "renovations-waterproofing-img-20240716-112237",
      "service": "renovations",
      "src": "/projects/renovations/waterproofing-img-20240716-112237.webp",
      "fallback": "/projects/renovations/waterproofing-img-20240716-112237.jpg",
      "alt": "Basement waterproofing in the GTA",
      "category": "Waterproofing",
      "w": 449,
      "h": 798
    },
    {
      "id": "renovations-waterproofing-img-20240716-111840",
      "service": "renovations",
      "src": "/projects/renovations/waterproofing-img-20240716-111840.webp",
      "fallback": "/projects/renovations/waterproofing-img-20240716-111840.jpg",
      "alt": "Basement waterproofing in the GTA",
      "category": "Waterproofing",
      "w": 449,
      "h": 798
    },
    {
      "id": "renovations-waterproofing-img-20240716-111839",
      "service": "renovations",
      "src": "/projects/renovations/waterproofing-img-20240716-111839.webp",
      "fallback": "/projects/renovations/waterproofing-img-20240716-111839.jpg",
      "alt": "Basement waterproofing in the GTA",
      "category": "Waterproofing",
      "w": 449,
      "h": 798
    }
  ]
};

// Flat list across all services
export const ALL_PROJECT_PHOTOS = Object.values(PROJECT_PHOTOS).flat();
